/* eslint-env jquery */

import { Controller } from "stimulus";
import creditCardType from "credit-card-type";
import TabbableInterface from "./reactivation_components/tabbable_interface";
import PaymentProcessor from "./reactivation_components/payment_processor";
import CreditCardFormValidator from "./reactivation_components/cc_form_validator";
import ReactivationHelper from "./reactivation_components/reactivation_helper";
import AccountReactivator from "./reactivation_components/account_reactivator";

export default class AccountReactivationController extends Controller {
  static targets = [
    "id", "name", "degreeTitle", "totalPriceMonthly", "totalPriceAnnual",
    "ccLast4", "ccType", "totalPrice", "paymentDate",
    "ccNumber", "cvv", "ccMonth", "ccYear", "ccPostalCode", "infoPaymentDetails",
    "billingForm", "gateway", "stripePaymentElement", "stripePaymentMethodId", "stripePaymentMethodType",
    "creditBreakdown", "originalPrice", "creditAmount", "totalCreditBalance",
    "displayMonthlyPrice", "displayAnnualPrice", "discountedAnnualPrice", "discountedMonthlyPrice",
    "discountBreakdown", "discountAmount"
  ];

  STAGES = {
    "tab-auth": 0, "tab-plan": 1, "tab-billing": 2, "tab-review": 3,
  };

  initialize = () => {
    this.tabbable = new TabbableInterface();
    this.helper = new ReactivationHelper();
    this.ccFormValidator = new CreditCardFormValidator();
    if (this.data.get("paymentOnFile") !== "None") {
      this.ccFormValidator.hideCCForm();
    } else {
      this.ccFormValidator.selectCCMethod();
    }
    this.memoized = {};
  }

  connect = () => {
    this.updateTargetContent("name", this.data.get("name"));

    const degreeTitle = this.data.get("degreeTitle");
    this.updateTargetContent("degreeTitle", degreeTitle ? ` - ${degreeTitle}` : '');

    this.updateTargetContent("paymentDate", this.paymentDate ?? '');

    this.updateTargetContent("totalPriceMonthly", this.data.get("totalPriceMonthly") ?? '');
    this.updateTargetContent("totalPriceAnnual", this.data.get("totalPriceAnnual") ?? '');
  }

  updateTargetContent(targetName, content) {
    try {
      const target = this[`${targetName}Target`];
      if (target) {
        target.innerHTML = content;
      }
    } catch (error) {
      console.warn(`Target element "${targetName}" is missing in the DOM.`);
    }
  }
  showTab(tab) {
    this.tabbable.showTab(tab);
    this.connect();
    this.helper.scrollTo("TOP");
    this.enableSubmitBtn();
  }

  switchBillingCycle = (event) => {
    let choice = null;
    if (!$(event.target).hasClass(".billing-option")) {
      choice = $(event.target).parents("div.billing-option");
    } else {
      choice = $(event.target);
    }

    choice.addClass("selected");
    choice.siblings(".selected").removeClass("selected");
    this.helper.scrollTo("TOP");

    // Get discounted price based on selection
    this.memoizedDiscountedPrice();
  }

  hasDiscount = () => !this.helper.isEmpty(this.data.get("discountCode"));

  disableSubmitBtn = () => {
    $(this.element).find("#submitBtn").addClass("disabled loading");
    this.data.set("prevent-fetch", true);
  }

  enableSubmitBtn = () => {
    $(this.element).find("#submitBtn").removeClass("disabled loading");
    this.data.set("prevent-fetch", false);
  }

  toggleNotices = (action, message, type) => {
    if (action === "remove") {
      $(".alert-banner").remove();
    } else {
      const alertBanner = `<div class="alert-banner ${type}" data-featurette="alert">`
        + `<p>${message}</p>`
        + "</div>";
      $(".content > .container").prepend(alertBanner);
    }
  }

  toggleDiscountBanner = (discountableCode, discountMessage) => {
    // When the user did not provide a discount
    if (!this.data.get("discountCode")) {
      return;
    }

    if (discountableCode === 0) {
      this.toggleNotices("remove");
      $(".discount-banner .discount-message").html(discountMessage);
      $(".discount-banner").show();
    } else if (discountableCode > 0 && $(".discount-banner").is(":hidden")) {
      this.toggleNotices("remove");
      this.toggleNotices("add", discountMessage, "warning");
      $(this.element).find(".discount-callout").hide();
    } else if (discountableCode > 0 && $(".discount-banner").is(":visible")) {
      this.toggleNotices("remove");
      this.toggleNotices("add", discountMessage, "warning");
      $(".discount-banner").hide();
      $(this.element).find(".discount-callout").hide();
    }

    $(this.element).css("padding-top", "30px");
  }

  memoizedDiscountedPrice = (callback) => {
    let url = `${this.data.get("discountPriceForUrl")}?plan=${this.data.get("id")}`;
    if (this.hasDiscount()) {
      url += `&discount_code=${this.data.get("discountCode")}`;
    }
    if (this.data.get("planChoice") === "degree") {
      url += "&degree=true";
    }

    if (this.data.get("planChoice") !== "degree"
        && $(this.element).find("input[name='billing_period']:checked").val() === "annual") {
      url += "&billing_period=annual";
    } else {
      url += "&billing_period=monthly";
    }

    const self = this;

    // Use memoized plan discount if available
    if (`${this.data.get("id")}_annual` in this.memoized
        && $(this.element).find("input[name='billing_period']:checked").val() === "annual") {
      this.toggleDiscountBanner(
        this.memoized[`${this.data.get("id")}_annual`].discountable_code,
        this.memoized[`${this.data.get("id")}_annual`].discount_message,
      );

      if (this.memoized[`${this.data.get("id")}_annual`].amount_due !== "$0") {
        this.data.set("discountPriceAnnual", this.memoized[`${this.data.get("id")}_annual`].amount_due);
        this.data.set("hasAnnualDiscount", "true");
      }

      if (callback) {
        callback();
      }
    } else if (`${this.data.get("id")}_monthly` in this.memoized
        && $(this.element).find("input[name='billing_period']:checked").val() === "monthly") {
      this.toggleDiscountBanner(
        this.memoized[`${this.data.get("id")}_monthly`].discountable_code,
        this.memoized[`${this.data.get("id")}_monthly`].discount_message,
      );

      this.data.set("discountPriceMonthly", this.memoized[`${this.data.get("id")}_monthly`].amount_due);

      if (callback) {
        callback();
      }
    } else {
      // Else fetch plan discount from server
      fetch(url)
        .then(data => data.json())
        .then((data) => {
          if (data.response.amount_due.monthly) {
            self.data.set("discountPriceMonthly", data.response.amount_due.monthly);
          }
          if (data.response.amount_due.annual) {
            self.data.set("discountPriceAnnual", data.response.amount_due.annual);
            // Set flag to indicate annual discount is available
            self.data.set("hasAnnualDiscount", "true");
          }

          const cycle = $(self.element).find("input[name='billing_period']:checked").val();
          const info = {
            [`${self.data.get("id")}_${cycle}`]: {
              discountable_code: data.response.discountable_code,
              discount_message: data.response.discount_message,
              amount_due: data.response.amount_due[`${cycle}`],
            },
          };

          Object.assign(self.memoized, info);
          self.toggleDiscountBanner(
            data.response.discountable_code,
            data.response.discount_message,
          );
          
          // Update the billing display with discount prices
          self.updateDiscountedPrices();

          if (callback) {
            callback();
          }
        });
    }
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * *
  *
  * Plan tab                                           *
  *
  * * * * * * * * * * * * * * * * * * * * * * * * * * */
  showPlanTab = (event) => {
    event.preventDefault();
    this.showTab("#tab-plan");
  }

  chooseDegree = () => {
    this.data.set("planChoice", "degree");
    const selectedDegree = $(this.element)
      .find(".plan-techdegree-selection-list input[name='techdegree-selection']:checked")
      .parent();

    $(".plan-selected-degree").text(selectedDegree.attr("data-degree-title"));
    $(".plan-techdegree").find("[data-selected-degree-projects-count]").text(selectedDegree.attr("data-degree-projects-count"));
  }

  choosePlan = () => {
    this.data.set("planChoice", "plan");
  }

  getDegreeChoiceTarget = (event) => {
    if ($(event.target).attr("id") === "continue-current-plan") {
      return $(event.target);
    }
    return $(this.element)
      .find(".plan-techdegree-selection-list input[name='techdegree-selection']:checked")
      .parent();
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * *
  *
  * Billing tab                                        *
  *
  * * * * * * * * * * * * * * * * * * * * * * * * * * */
  showBillingTab = (event) => {
    if (event) {
      event.preventDefault();
    }

    // Initialize Stripe for card entry unless humble bundle
    if (!this.data.get("humbleBundle")) {
      this.initializeStripe();
    }

    if ($(event.target).parents("#tab-plan-content").length) {
      if ($(event.target).html() === "Switch Plan") {
        this.chooseDegree();
      }

      if (this.data.get("planChoice") === "degree") {
        // User selected a Techdegree
        const selectedTD = this.getDegreeChoiceTarget(event);
        this.data.set("id", selectedTD.attr("data-plan-addon-id"));
        this.data.set("name", selectedTD.attr("data-plan-name"));
        this.data.set("totalPriceMonthly", selectedTD.attr("data-total-price-monthly"));
        this.data.set("totalPriceAnnual", selectedTD.attr("data-total-price-annual"));
        this.data.set("degreeTitle", selectedTD.attr("data-degree-title"));
        this.data.set("billingPeriod", "monthly");
        $(this.element).find("#billing-cycle-container").css("display", "none");
        if (selectedTD.attr("data-plan-addon-id") === undefined) {
          return;
        }
      } else {
        // User selected other plans  
        const button = event.currentTarget || $(event.target).closest("button")[0];
        this.data.set("id", $(button).attr("data-plan-id"));
        this.data.set("name", $(button).attr("data-plan-name"));
        this.data.set("totalPriceMonthly", $(button).attr("data-total-price-monthly"));
        this.data.set("totalPriceAnnual", $(button).attr("data-total-price-annual"));
        this.data.set("degreeTitle", "");
        
        // Handle annual-only plans
        const isAnnualOnly = $(button).attr("data-annual-only") === "true";
        if (isAnnualOnly) {
          $(this.element).find("#subscribe_monthly").hide();
          $(this.element).find("#billing-cycle-container .h4").text("Your price");
          $(this.element).find("#subscribe_annually input").prop("checked", true);
          this.data.set("billingPeriod", "annual");
        } else {
          $(this.element).find("#subscribe_monthly").show();
          $(this.element).find("#billing-cycle-container .h4").text("Your billing cycle");
        }
        
        $(this.element).find("#billing-cycle-container").css("display", "");
        
        // Update the displayed prices in the billing form
        this.updateDisplayedPrices();
      }
    }

    if (this.hasDiscount()) {
      this.memoizedDiscountedPrice(() => {
        this.showTab("#tab-billing");
      });
    } else {
      this.showTab("#tab-billing");
    }
  }

  hasAnnualDiscount = () => this.data.get("hasAnnualDiscount") === "true";

  togglePaymentMethod = () => {
    this.ccFormValidator.togglePaymentMethod();
  }

  updateDisplayedPrices = () => {
    // Update monthly price if target exists
    if (this.hasDisplayMonthlyPriceTarget) {
      const monthlyPrice = this.data.get("totalPriceMonthly");
      this.displayMonthlyPriceTargets.forEach(target => {
        // Only update if not inside a strikethrough (those are static)
        if (!target.closest('.strikethrough')) {
          target.textContent = monthlyPrice;
        }
      });
    }

    // Update annual price if target exists
    if (this.hasDisplayAnnualPriceTarget) {
      const annualPrice = this.data.get("totalPriceAnnual");
      this.displayAnnualPriceTargets.forEach(target => {
        // Only update if not inside a strikethrough (those are static)
        if (!target.closest('.strikethrough')) {
          target.textContent = annualPrice;
        }
      });
    }
    
    // Update discounted prices if targets exist
    this.updateDiscountedPrices();
  }
  
  updateDiscountedPrices = () => {
    const discountPriceMonthly = this.data.get("discountPriceMonthly");
    const discountPriceAnnual = this.data.get("discountPriceAnnual");
    const originalMonthly = this.data.get("totalPriceMonthly");
    const originalAnnual = this.data.get("totalPriceAnnual");
    
    // Update annual discounted price only if different from original
    if (this.hasDiscountedAnnualPriceTarget) {
      this.discountedAnnualPriceTargets.forEach(target => {
        const priceContainer = target.closest('.price');
        const strikethroughSpan = priceContainer?.querySelector('.strikethrough');
        const regularPriceSpan = priceContainer?.querySelector('.regular-price');
        
        if (discountPriceAnnual && discountPriceAnnual !== originalAnnual) {
          // Show discount
          target.innerHTML = `${discountPriceAnnual}/yr`;
          target.style.display = '';
          // Show strikethrough wrapper
          if (strikethroughSpan) {
            strikethroughSpan.style.display = '';
          }
          // Hide regular price
          if (regularPriceSpan) {
            regularPriceSpan.style.display = 'none';
          }
        } else {
          // Hide discount
          target.style.display = 'none';
          // Hide strikethrough wrapper
          if (strikethroughSpan) {
            strikethroughSpan.style.display = 'none';
          }
          // Show regular price
          if (regularPriceSpan) {
            regularPriceSpan.style.display = '';
          }
        }
      });
    }
    
    // Update monthly discounted price only if different from original
    if (this.hasDiscountedMonthlyPriceTarget) {
      this.discountedMonthlyPriceTargets.forEach(target => {
        const priceContainer = target.closest('.price');
        const strikethroughSpan = priceContainer?.querySelector('.strikethrough');
        const regularPriceSpan = priceContainer?.querySelector('.regular-price');
        
        if (discountPriceMonthly && discountPriceMonthly !== originalMonthly) {
          // Show discount
          target.innerHTML = `${discountPriceMonthly}/mo`;
          target.style.display = '';
          if (strikethroughSpan) {
            strikethroughSpan.style.display = '';
          }
          if (regularPriceSpan) {
            regularPriceSpan.style.display = 'none';
          }
        } else {
          // Hide discount
          target.style.display = 'none';
          if (strikethroughSpan) {
            strikethroughSpan.style.display = 'none';
          }
          if (regularPriceSpan) {
            regularPriceSpan.style.display = '';
          }
        }
      });
    }
  }

  toggleChangeTechdegreePanel() {
    if ($(this.element).find(".techdegree-topic-selection").hasClass("hidden")) {
      $(this.element).find(".techdegree-topic-selection").removeClass("hidden");
      this.helper.scrollTo(".techdegree-topic-selection");
    } else {
      $(this.element).find(".techdegree-topic-selection").addClass("hidden");
    }
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * *
  *
  * Review tab                                         *
  *
  * * * * * * * * * * * * * * * * * * * * * * * * * * */
  showReviewTab = (event) => {
    event.preventDefault();
  
    if ($(event.target).hasClass("disabled")) {
      return;
    }
  
    // Treat as Stripe flow if the Stripe Payment Element is present/initialized
    const isStripeUI = !!document.getElementById("stripe-payment-element");
    const isStripeGateway = this.data.get("gateway") === "stripe";
    if (!(isStripeUI || isStripeGateway)) {
      if (!this.ccFormValidator.isPaypal() && !this.ccFormValidator.validateFields()) {
        return;
      }
  
      // Store payment info
      if (this.ccFormValidator.isCC()) {
        this.ccType = this.helper.upperCaseFirstLetter(
          creditCardType(this.ccNumberTarget.value)[0].type,
        );
        this.ccLast4 = this.ccNumberTarget.value.substr(-4);
      }
  
      // Store billing cycle
      if (this.data.get("degreeTitle")) {
        // The billing period is always monthly for degree students
        this.data.set("billingPeriod", "monthly");
      } else {
        this.data.set("billingPeriod", $(this.element).find("input[name='billing_period']:checked").val());
      }
  
      this.displayPaymentInformation();
  
      // Get original price and discount price
      const originalPrice = this.data.get("billingPeriod") === "monthly" 
        ? this.data.get("totalPriceMonthly")
        : this.data.get("totalPriceAnnual");
      
      let discountedPrice = null;
      let hasDiscount = false;
      
      // Retrieve discount plan prices
      if (this.hasDiscount() && this.data.get("billingPeriod") === "monthly") {
        discountedPrice = this.data.get("discountPriceMonthly");
        hasDiscount = discountedPrice !== originalPrice;
        this.totalPrice = discountedPrice;
      } else if (this.hasAnnualDiscount() && this.data.get("billingPeriod") === "annual") {
        discountedPrice = this.data.get("discountPriceAnnual");
        hasDiscount = discountedPrice !== originalPrice;
        this.totalPrice = discountedPrice;
      } else {
        this.totalPrice = originalPrice;
      }
  
      // Apply credit balance to reduce the charge amount
      this.totalPrice = this.calculateChargeWithCredits(this.totalPrice, originalPrice, hasDiscount);

      this.totalPriceTarget.innerHTML = this.totalPrice;
  
      const url = [`${this.data.get("reviewUrl")}?plan_id=${this.data.get("id")}`,
        `&degree=${!this.helper.isEmpty(this.data.get("degreeTitle"))}`].join("");
      const self = this;
      $.get(url, (data) => {
        self.paymentDate = data.response.payment_date;
        this.showTab("#tab-review");
      });
    } else {
      // Handle Stripe case
      // Store billing cycle
      if (this.data.get("degreeTitle")) {
        // The billing period is always monthly for degree students
        this.data.set("billingPeriod", "monthly");
      } else {
        this.data.set("billingPeriod", $(this.element).find("input[name='billing_period']:checked").val());
      }
  
      this.displayPaymentInformation();
  
      // Get original price and discount price
      const originalPrice = this.data.get("billingPeriod") === "monthly" 
        ? this.data.get("totalPriceMonthly")
        : this.data.get("totalPriceAnnual");
      
      let discountedPrice = null;
      let hasDiscount = false;
      
      // Retrieve discount plan prices
      if (this.hasDiscount() && this.data.get("billingPeriod") === "monthly") {
        discountedPrice = this.data.get("discountPriceMonthly");
        hasDiscount = discountedPrice !== originalPrice;
        this.totalPrice = discountedPrice;
      } else if (this.hasAnnualDiscount() && this.data.get("billingPeriod") === "annual") {
        discountedPrice = this.data.get("discountPriceAnnual");
        hasDiscount = discountedPrice !== originalPrice;
        this.totalPrice = discountedPrice;
      } else {
        this.totalPrice = originalPrice;
      }
  
      // Apply credit balance to reduce the charge amount
      this.totalPrice = this.calculateChargeWithCredits(this.totalPrice, originalPrice, hasDiscount);

      this.totalPriceTarget.innerHTML = this.totalPrice;
  
      const url = [`${this.data.get("reviewUrl")}?plan_id=${this.data.get("id")}`,
        `&degree=${!this.helper.isEmpty(this.data.get("degreeTitle"))}`].join("");
      const self = this;
      $.get(url, (data) => {
        self.paymentDate = data.response.payment_date;
        this.showTab("#tab-review");
      });
    }
  }  

  displayPaymentInformation = () => {
    const hasStripeElement = !!document.getElementById("stripe-payment-element");
    const isStripeGateway = this.data.get("gateway") === "stripe";

    if (hasStripeElement || isStripeGateway) {
      // Stripe Payment Element manages card details; we don't expose brand/last4 here
      this.infoPaymentDetailsTarget.innerHTML = "<p>Debit or Credit Card</p>";
    } else if (this.ccFormValidator.isPaypal()) {
      const paypalType = "<p>Paypal</p>";
      const paypalMssg = "<p class='paypal-chosen'>"
        + "When you click '<strong>Confirm and Pay</strong>' below we'll take you to "
        + "Paypal's site to set up your billing information.</p>";
      this.infoPaymentDetailsTarget.innerHTML = `${paypalType} ${paypalMssg}`;
    } else if (this.ccFormValidator.isCC()) {
      const brand = this.ccType ? this.ccType.replace(/-/g, " ") : "Card";
      const last4 = this.ccLast4 || "••••";
      const ccMssg = `${brand} ending with ${last4}`;
      this.infoPaymentDetailsTarget.innerHTML = ccMssg;
    } else if (this.ccFormValidator.isOnFile()) {
      const onFileMssg = `${this.data.get("paymentOnFile")}`;
      this.infoPaymentDetailsTarget.innerHTML = onFileMssg;
    }
  }
  
  initializeStripe = () => {
    this.stripeConfig = JSON.parse(this.billingFormTarget.getAttribute("data-stripe-config"));
    if (this.stripeConfig) {
      const { publishable_key, client_secret } = this.stripeConfig;
      this.stripe = new Stripe(publishable_key);
      this.elements = this.stripe.elements({ clientSecret: client_secret });
      this.paymentElement = this.elements.create("payment", { appearance: { theme: "stripe" } });
      this.paymentElement.mount(this.stripePaymentElementTarget);
      this.clientSecret = client_secret;
    } else {
      console.error("Stripe config is not provided.");
    }
  }  

  createStripePaymentMethod = () => {
    if (!this.elements) {
      console.error("Stripe elements not initialized.");
      this.enableSubmitBtn();
      return;
    }

    if (!this.ccFormValidator.isOnFile()) {
      this.elements.submit().then(() => {
        this.stripe.confirmSetup({
          elements: this.elements,
          clientSecret: this.clientSecret,
          confirmParams: {
            return_url: window.location.href,
          },
          redirect: 'if_required',
        }).then((result) => {
          if (result.error) {
            this.enableSubmitBtn();
            console.error(result.error.message);
          } else if (result.setupIntent) {
            this.stripePaymentMethodIdTarget.value = result.setupIntent.payment_method;
            this.stripePaymentMethodTypeTarget.value = result.setupIntent.payment_method_types[0];
            this.processStripePaymentMethod();
          }
        }).catch((error) => {
          this.enableSubmitBtn();
          console.error(error.message);
        });
      }).catch((error) => {
        this.enableSubmitBtn();
        console.error("Error submitting elements:", error);
      });
    } else if (this.stripeConfig.stripe_payment_method_id && this.stripeConfig.stripe_payment_method_type) {
      this.processStripePaymentMethod(this.stripeConfig.stripe_payment_method_id, this.stripeConfig.stripe_payment_method_type);
    }
  }  
  
  processStripePaymentMethod = (stripe_payment_method_id = null, stripe_payment_method_type = null) => {
    const postalCode = this.hasStripePostalCodeTarget ? this.ccPostalCodeTarget.value : '';
  
    const reactivator = new AccountReactivator(
      this.data.get("id"),
      this.data.get("billingPeriod"),
      this.data.get("discountCode"),
      null,  // Stripe does not use payment nonce
      postalCode,
      this.ccFormValidator.isOnFile(),
      this,
      this.data.get("gateway"),  // Pass the gateway information
      this.stripePaymentMethodIdTarget.value || stripe_payment_method_id,  // Use the Stripe payment method ID here
      this.stripePaymentMethodTypeTarget.value || stripe_payment_method_type
    );
    if (this.data.get("planChoice") === "degree") {
      reactivator.setPlanType("degree");
    } else {
      reactivator.setPlanType("plan");
    }
    reactivator.reactivate();
  }  

  submit = () => {
    if (this.data.get("prevent-fetch") === "true") {
      return;
    }

    this.disableSubmitBtn();

    // For humble bundle, skip payment processing and reactivate directly
    if (this.data.get("humbleBundle")) {
      const reactivator = new AccountReactivator(
        this.data.get("id"),
        this.data.get("billingPeriod"),
        this.data.get("discountCode"),
        null, // no payment nonce needed
        null, // no postal code needed
        false, // not using payment on file
        this,
        null, // no gateway needed
        null, // no stripe payment method needed
        null  // no stripe payment method type needed
      );
      if (this.data.get("planChoice") === "degree") {
        reactivator.setPlanType("degree");
      } else {
        reactivator.setPlanType("plan");
      }
      reactivator.reactivate();
      return;
    }

    // If a stripe user chooses Paypal , we need to change the gateway to braintree
    if (this.ccFormValidator.isPaypal() && this.data.get("gateway") == "stripe"){
      this.data.set("gateway", "braintree");
      this.element.setAttribute("data-account-reactivation-gateway", "braintree");
    }
    // If user chooses Debit/Credit Card, ensure we use Stripe flow
    if (this.ccFormValidator.isCC()) {
      this.data.set("gateway", "stripe");
      this.element.setAttribute("data-account-reactivation-gateway", "stripe");
    }
  
    if (this.data.get("gateway") === "stripe") {
      this.createStripePaymentMethod();
    } else {
      // Run validations if the gateway is not Stripe
      if (!this.ccFormValidator.isPaypal() && !this.ccFormValidator.validateFields()) {
        this.enableSubmitBtn();
        return;
      }
  
      let paymentType = null;
      if (this.ccFormValidator.isPaypal()) {
        paymentType = "paypal";
      } else if (this.ccFormValidator.isCC()) {
        paymentType = "credit_card";
      } else if (this.ccFormValidator.isOnFile()) {
        paymentType = "on_file";
      }
      const paymentProcessor = new PaymentProcessor(paymentType, this.ccFormValidator, this);
      paymentProcessor.process();
    }
  }

  // Calculate the actual charge amount after applying available credits
  calculateChargeWithCredits(priceString, originalPriceString = null, hasDiscount = false) {
    if (!priceString) return priceString;

    // Extract numeric value from price string (e.g., "$25.00" -> 25.00)
    const priceMatch = priceString.match(/[\d,]+\.?\d*/);
    if (!priceMatch) return priceString;

    const priceAmount = parseFloat(priceMatch[0].replace(/,/g, ''));
    const creditBalance = parseInt(this.data.get("creditBalance")) || 0;
    const creditAmountInDollars = creditBalance / 100;

    // Calculate the amount after applying credits
    const chargeAmount = Math.max(0, priceAmount - creditAmountInDollars);

    // Format back to currency string, preserving the original format
    const currencySymbol = priceString.match(/^[^\d,]*/)?.[0] || '$';
    const suffix = priceString.match(/[^\d,]*$/)?.[0] || '';
    
    // Show breakdown if credits or discounts are being applied
    if (creditAmountInDollars > 0 || hasDiscount) {
      this.showCreditBreakdown(originalPriceString || priceString, creditAmountInDollars, currencySymbol, suffix, hasDiscount, priceString);
    } else {
      this.hideCreditBreakdown();
    }
    
    if (chargeAmount === 0) {
      return `${currencySymbol}0.00${suffix}`;
    } else {
      return `${currencySymbol}${chargeAmount.toFixed(2)}${suffix}`;
    }
  }

  // Show the credit breakdown section with original price and credit applied
  showCreditBreakdown(originalPriceString, creditAmountInDollars, currencySymbol, suffix, hasDiscount = false, discountedPriceString = null) {
    const creditBreakdownTarget = this.targets.find("creditBreakdown");
    const originalPriceTarget = this.targets.find("originalPrice");
    const creditAmountTarget = this.targets.find("creditAmount");
    const totalCreditBalanceTarget = this.targets.find("totalCreditBalance");
    const discountBreakdownTarget = this.targets.find("discountBreakdown");
    const discountAmountTarget = this.targets.find("discountAmount");

    if (creditBreakdownTarget && originalPriceTarget && creditAmountTarget && totalCreditBalanceTarget) {
      // Show original price
      originalPriceTarget.textContent = originalPriceString;
      
      // Show discount line if there's a discount
      if (hasDiscount && discountBreakdownTarget && discountAmountTarget && discountedPriceString) {
        // Calculate discount amount
        const originalMatch = originalPriceString.match(/[\d,]+\.?\d*/);
        const discountedMatch = discountedPriceString.match(/[\d,]+\.?\d*/);
        
        if (originalMatch && discountedMatch) {
          const originalAmount = parseFloat(originalMatch[0].replace(/,/g, ''));
          const discountedAmount = parseFloat(discountedMatch[0].replace(/,/g, ''));
          const discountAmountValue = originalAmount - discountedAmount;
          
          if (discountAmountValue > 0) {
            const discountString = `-${currencySymbol}${discountAmountValue.toFixed(2)}`;
            discountAmountTarget.textContent = discountString;
            discountBreakdownTarget.style.display = "block";
          } else {
            discountBreakdownTarget.style.display = "none";
          }
        }
      } else if (discountBreakdownTarget) {
        discountBreakdownTarget.style.display = "none";
      }
      
      // Show credit amount being applied
      const priceForCredits = hasDiscount && discountedPriceString ? discountedPriceString : originalPriceString;
      const priceMatch = priceForCredits.match(/[\d,]+\.?\d*/);
      const priceAmount = priceMatch ? parseFloat(priceMatch[0].replace(/,/g, '')) : 0;
      const creditAmountToApply = Math.min(creditAmountInDollars, priceAmount);
      creditAmountTarget.textContent = `-${currencySymbol}${creditAmountToApply.toFixed(2)}${suffix}`;
      
      // Show total credit balance
      totalCreditBalanceTarget.textContent = `${currencySymbol}${creditAmountInDollars.toFixed(2)}${suffix}`;
      
      // Show the breakdown section
      creditBreakdownTarget.style.display = 'block';
    }
  }

  // Hide the credit breakdown section
  hideCreditBreakdown() {
    const creditBreakdownTarget = this.targets.find("creditBreakdown");
    const discountBreakdownTarget = this.targets.find("discountBreakdown");
    
    if (creditBreakdownTarget) {
      creditBreakdownTarget.style.display = 'none';
    }
    
    if (discountBreakdownTarget) {
      discountBreakdownTarget.style.display = 'none';
    }
  }  
}
